import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { CreditCardModel } from '../../MyCreditCards/models/models'

export class DeleteCreditCardApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/deleteCreditCard',
      requesterInfo,
    })
  }

  public async deleteCard(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
